import React from 'react';
import PropTypes from 'prop-types';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import { Bert } from 'meteor/themeteorchef:bert';

import { Alert, Autocomplete } from '@mui/material';
import { isEmpty, map, isEqual, find } from 'lodash';
import { renderTextField } from '../MaterialMUIComponent';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import Loading from '../Loading';

import Sources from '../../../api/Sources/Sources';
import * as sourceOps from '../../../api/Sources/source-operations';

const ConnectionDataBase = ({
  sourcesList,
  loading,
  sourceSelected,
  setSourceSelected,
  isSourceAttributes,
  isTypeSourceAttributes,
  setSourceAttributes,
  setTypesAttributes,
  searchSource,
  styleProp
}) => {
  const [lodingSearchSource, setLoadingSearchSource] = React.useState(false);
  const handleSourceTypesAttributes = async source => {
    try {
      const connectorSelected = await methodPromise(
        'connectors.findOne',
        sourceOps.getConnectorId(source)
      );

      if (!isEmpty(connectorSelected)) {
        const { user, ip, port, password, schema, databaseName } = connectorSelected;
        const getTypesFieldSchema = {
          user,
          databaseName,
          ip,
          port,
          password,
          schema,
          tableName: sourceOps.getLayerName(source)
        };
        const response = await fetch(
          'https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/upload_to_database',
          {
            method: 'POST',
            body: JSON.stringify({
              connection: getTypesFieldSchema
            }),
            headers: { 'Content-Type': 'application/json' }
          }
        );
        const answerTypesSchema = await response.json();
        map(Object.keys(answerTypesSchema), keyType => {
          let typeValue = answerTypesSchema[keyType];
          if (typeValue.includes('character')) {
            typeValue = 'Text';
          } else if (typeValue.includes('integer')) {
            typeValue = 'Number';
          } else if (typeValue.includes('timestamp')) {
            typeValue = 'Date';
          }
          answerTypesSchema[keyType] = typeValue;
        });
        setTypesAttributes(answerTypesSchema);
        Bert.alert('Types attributes sources', 'success');
      } else Bert.alert('There has been a problem with connection, not found', 'warning');
    } catch (error) {
      handleErrorInClient(error);
      Bert.alert('There has been a problem obtaining source attributes types', 'warning');
    }
  };

  const handleSourceAttributes = async source => {
    if (isSourceAttributes && !isEmpty(source))
      try {
        const sourceAttributes = {
          connectorId: sourceOps.getConnectorId(source),
          layerNameSource: sourceOps.getLayerNameSource(source),
          layerName: sourceOps.getLayerName(source)
        };
        const attributes = await methodPromise('sources.listSourceAttributes', sourceAttributes);
        setSourceAttributes(attributes);
        Bert.alert('Attributes sources', 'success');
      } catch (error) {
        handleErrorInClient(error);
        Bert.alert('There has been a problem obtaining attributes sources', 'warning');
      }
    if (isTypeSourceAttributes && !isEmpty(source)) handleSourceTypesAttributes(source);
    setSourceSelected(source);
    setLoadingSearchSource(false);
  };

  React.useEffect(() => {
    if (!isEmpty(searchSource) && !isEmpty(sourcesList)) {
      const source = find(sourcesList, item => isEqual(sourceOps.getId(item), searchSource));
      if (!isEmpty(source)) {
        setLoadingSearchSource(true);
        handleSourceAttributes(source);
      }
    }
  }, [searchSource]);
  return (
    <>
      {loading || lodingSearchSource ? (
        <Loading />
      ) : (
        <>
          {!isEmpty(sourcesList) && (
            <Autocomplete
              key={`${sourceOps.getId(sourceSelected)}`}
              size="small"
              options={sourcesList}
              getOptionLabel={option => option.name}
              onChange={(index, newValue) =>
                handleSourceAttributes(isEmpty(newValue) ? {} : newValue)
              }
              value={!isEmpty(sourceSelected) ? sourceSelected : { name: '' }}
              isOptionEqualToValue={(option, value) => option.name === value.name}
              renderInput={params =>
                renderTextField({
                  key: `select-source-${sourceOps.getId(sourceSelected)}`,
                  moreProps: {
                    ...params,
                    placeholder: 'Select source',
                    label: 'Sources'
                  }
                })
              }
              renderOption={(props, option) => (
                <li {...props} key={option._id}>
                  {option.name}
                </li>
              )}
              style={styleProp}
            />
          )}
          {isEmpty(sourcesList) && (
            <Alert margintop="5%" severity="warning">
              Not found sources
            </Alert>
          )}
        </>
      )}
    </>
  );
};

ConnectionDataBase.defaultProps = {
  sourcesList: [],
  loading: false,
  isSourceAttributes: false,
  isTypeSourceAttributes: false,
  setSourceAttributes: () => {},
  setTypesAttributes: () => {},
  searchSource: '',
  styleProp: { width: '100%' }
};

ConnectionDataBase.propTypes = {
  sourcesList: PropTypes.array,
  loading: PropTypes.bool,
  sourceSelected: PropTypes.object.isRequired,
  setSourceSelected: PropTypes.func.isRequired,
  isSourceAttributes: PropTypes.bool,
  isTypeSourceAttributes: PropTypes.bool,
  setSourceAttributes: PropTypes.func,
  setTypesAttributes: PropTypes.func,
  searchSource: PropTypes.string,
  styleProp: PropTypes.object
};

export default withTracker(({ filterConnectors }) => {
  const filter = !isEmpty(filterConnectors) ? filterConnectors : { deleted: { $eq: 'no' } };
  const sourcesSub = Meteor.subscribe('sources');
  return {
    sourcesList: Sources.find(filter).fetch(),
    loading: !sourcesSub.ready()
  };
})(ConnectionDataBase);
